export const BLACK_COLOR = 'black';
export const GREEN_COLOR = 'green';
export const RED_COLOR = 'red';
export const ORANGE_COLOR = 'orange';

export const orderTypeCodes = [
    { label: 'B2C', value: 'b2c' },
    { label: 'B2B', value: 'b2b' },
    { label: 'Transfer', value: 'transfer' },
];

export const langCodes = [
    { label: 'Česky', value: 'CZ' },
    { label: 'English', value: 'EN' },
];
export const langCodesEmailTemplate = [
    { label: 'CZ', value: 'CZ' },
    { label: 'EN', value: 'EN' },
    { label: 'SK', value: 'SK' },
];

export const activeCodes = [
    { label: 'utils.activeCodes.nonActive', value: 0, color: 'orange' },
    { label: 'utils.activeCodes.active', value: 1, color: 'green' },
];

export const boolCodes = [
    { label: 'utils.boolCodes.yes', value: true },
    { label: 'utils.boolCodes.no', value: false },
];

export const boolNumberCodes = [
    { label: 'utils.boolCodes.yes', value: 1, color: 'green' },
    { label: 'utils.boolCodes.no', value: 0, color: 'red' },
];

export const scanImeiSnCodes = [
    { label: 'utils.scanImeiSnCodes.no', value: 'none', color: 'red' },
    { label: 'utils.scanImeiSnCodes.snExpedition', value: 'snExpedition' },
    { label: 'utils.scanImeiSnCodes.imeiExpedition', value: 'imeiExpedition' },
    { label: 'utils.scanImeiSnCodes.snInbound', value: 'snInbound' },
    { label: 'utils.scanImeiSnCodes.imeiInbound', value: 'imeiInbound' },
    { label: 'utils.scanImeiSnCodes.snBoth', value: 'snBoth' },
    { label: 'utils.scanImeiSnCodes.imeiBoth', value: 'imeiBoth' },
];

export const batteryTypeColors: { [key: string]: string } = {
    no: 'red',
};

export const activeNumberCodes = [
    { label: 'utils.activeNumberCodes.deleted', value: 2, color: 'green' },
    { label: 'utils.activeNumberCodes.yes', value: 1, color: 'green' },
    { label: 'utils.activeNumberCodes.no', value: 0, color: 'red' },
];

export const configItemTypeCodes = [
    { label: 'utils.configItemTypeCodes.string', value: 'string' },
    { label: 'utils.configItemTypeCodes.number', value: 'number' },
    { label: 'utils.configItemTypeCodes.boolean', value: 'boolean' },
    { label: 'utils.configItemTypeCodes.multiline', value: 'multiline' },
];

export const providerFileTypeCodes = [
    { label: 'utils.providerFileTypeCodes.providerContract', value: 'providerContract' },
    { label: 'utils.providerFileTypeCodes.other', value: 'other' },
];

export const lineStateCodes = [
    { label: 'utils.lineState.e', value: 'e' },
    { label: 'utils.lineState.e', value: 'E' },
    { label: 'utils.lineState.d', value: 'd' },
    { label: 'utils.lineState.d', value: 'D' },
];

export const applicationMessageCodes = [
    { ID:1, LABEL: 'info', VALUE: 'info' },
    { ID:2, LABEL: 'error', VALUE: 'error' },
    { ID:3, LABEL: 'warning', VALUE: 'warning' },
];

export const orderClaimReturnTypeCodes = [
    { label: 'utils.orderClaimReturnType.claim', value: 'claim' },
    { label: 'utils.orderClaimReturnType.return', value: 'return' },
];

export const claimErrorDepartmentCodes = [
    { label: 'claimDetail.errorDepartment.b2c', value: 'b2c' },
    { label: 'claimDetail.errorDepartment.b2b', value: 'b2b' },
];

export const claimErrorCategoryCodes = [
    { label: 'claimDetail.errorCategory.packagingNonCompliance', value: 'packagingNonCompliance' },
    { label: 'claimDetail.errorCategory.physicalHandlingError', value: 'physicalHandlingError' },
    { label: 'claimDetail.errorCategory.scanningError', value: 'scanningError' },
    { label: 'claimDetail.errorCategory.insufficientPackaging', value: 'insufficientPackaging' },
    { label: 'claimDetail.errorCategory.others', value: 'others' },
];

export const claimErrorSeverityCodes = [
    { label: 'claimDetail.errorSeverity.1', value: 1 },
    { label: 'claimDetail.errorSeverity.2', value: 2 },
    { label: 'claimDetail.errorSeverity.3', value: 3 },
];

export const orderProductFileTypeCodes = [
    { label: 'utils.orderProductFileType.other', value: 'other' },
    { label: 'utils.orderProductFileType.engravingTemplate', value: 'engravingTemplate' },
];

export const orderProductCustomizationTypeCodes = [
    { label: 'utils.orderProductCustomizationType.stamping', value: 'stamping' },
    { label: 'utils.orderProductCustomizationType.grinding', value: 'grinding' },
    { label: 'utils.orderProductCustomizationType.engraving', value: 'engraving' },
];

export const currencyCodes = [
    { label: 'CZK', value: 'CZK' },
    { label: 'EUR', value: 'EUR' },
    { label: 'CHF', value: 'CHF' },
    { label: 'USD', value: 'USD' },
    { label: 'AUD', value: 'AUD' },
    { label: 'BGN', value: 'BGN' },
    { label: 'BRL', value: 'BRL' },
    { label: 'CAD', value: 'CAD' },
    { label: 'CNY', value: 'CNY' },
    { label: 'DKK', value: 'DKK' },
    { label: 'GBP', value: 'GBP' },
    { label: 'HKD', value: 'HKD' },
    { label: 'HRK', value: 'HRK' },
    { label: 'HUF', value: 'HUF' },
    { label: 'IDR', value: 'IDR' },
    { label: 'ILS', value: 'ILS' },
    { label: 'INR', value: 'INR' },
    { label: 'JPY', value: 'JPY' },
    { label: 'KRW', value: 'KRW' },
    { label: 'LTL', value: 'LTL' },
    { label: 'LVL', value: 'LVL' },
    { label: 'MXN', value: 'MXN' },
    { label: 'MYR', value: 'MYR' },
    { label: 'NOK', value: 'NOK' },
    { label: 'NZD', value: 'NZD' },
    { label: 'PHP', value: 'PHP' },
    { label: 'PLN', value: 'PLN' },
    { label: 'RON', value: 'RON' },
    { label: 'RUB', value: 'RUB' },
    { label: 'SEK', value: 'SEK' },
    { label: 'SGD', value: 'SGD' },
    { label: 'THB', value: 'THB' },
    { label: 'TRY', value: 'TRY' },
    { label: 'ZAR', value: 'ZAR' },
];

export const claimStatusOrder = [
    'received',
    'inProcess',
    'moreInfoNeeded',
    'informationAdded',
    'acceptedWaitingForCompensationFromShipper',
    'acceptedPendingClientCompensation',
    'accepted',
    'rejected',
    'storno',
];
export const claimStatusColors = {
    received: BLACK_COLOR,
    informationAdded: ORANGE_COLOR,
    inProcess: ORANGE_COLOR,
    rejected: RED_COLOR,
    storno: RED_COLOR,
    accepted: GREEN_COLOR,
    acceptedWaitingForCompensationFromShipper: ORANGE_COLOR,
    acceptedPendingClientCompensation: ORANGE_COLOR,
    moreInfoNeeded: ORANGE_COLOR,
};
export const returnStatusOrder = ['awaiting', 'received', 'confirmed', 'canceled'];
export const returnStatusColors = {
    awaiting: BLACK_COLOR,
    received: ORANGE_COLOR,
    confirmed: GREEN_COLOR,
    canceled: RED_COLOR,
};

export const applicationMessageTypesColors = {
    info: '#03a9f4',
    warning: '#ff9800',
    error: '#ef5350',
}

export const applicationMessageTypesOrder = ['info', 'warning', 'error'];

// Provider status colors based on the design specification
export const providerStatusColors: { [key: string]: string } = {
    created: '#808080',
    onboarding: '#808080',
    active: '#4caf50',
    scheduledOffboarding: '#FFC107',
    inactiveDataExport: '#FF9800',
    inactiveNoTransfers: '#F44336',
    storedGoodsOnly: '#FFC107',
};

export const providerStatusOrder = [
    'created',
    'onboarding',
    'active',
    'scheduledOffboarding',
    'inactiveDataExport',
    'inactiveNoTransfers',
    'storedGoodsOnly',
];
export const transportStatusColors = {};
export const receivingStatusOrder = ['awaiting', 'unloaded', 'received', 'confirmed', 'canceled'];
export const receivingStatusColors = {
    awaiting: BLACK_COLOR,
    received: ORANGE_COLOR,
    confirmed: GREEN_COLOR,
    canceled: RED_COLOR,
};
export const orderStatusColors = {
    preReceived: BLACK_COLOR,
    preOrder: BLACK_COLOR,
    productsNotAvailable: ORANGE_COLOR,
    waitingForPayment: ORANGE_COLOR,
    canceled: RED_COLOR,
    incorrect: RED_COLOR,
    suspended: ORANGE_COLOR,
    waitingForShipment: BLACK_COLOR,
    received: BLACK_COLOR,
    inProcess: BLACK_COLOR,
    packed: BLACK_COLOR,
    waitingForCarrier: BLACK_COLOR,
    onTheWay: GREEN_COLOR,
    atPickupPoint: GREEN_COLOR,
    lost: RED_COLOR,
    returningBack: ORANGE_COLOR,
    returnedBack: ORANGE_COLOR,
    delivered: GREEN_COLOR,
    processing: BLACK_COLOR,
};
